import { Base } from "ui/Scripts/source/framework/base";
import { ITaskStateListItem, TaskStateListItem } from "../taskState/taskStateListItem";
import { ITaskTypeEditItem, TaskTypeEditItem } from "./taskTypeEditItem";
import { ITaskPriorityListItem, TaskPriorityListItem } from "../taskPriority/taskPriorityListItem";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { IRecordUnit, RecordUnit } from "ui/Scripts/source/models/unit/recordUnit";

export interface ITaskTypeEdit {
    item: ITaskTypeEditItem;
    taskTypeUnits: IRecordUnit[];
    taskStates: ITaskStateListItem[];
    taskPriorities: ITaskPriorityListItem[];
    units: IIdTitleNode[];
}

export class TaskTypeEdit implements ITaskTypeEdit {
    item: TaskTypeEditItem;
    taskTypeUnits: RecordUnit[];
    taskStates: TaskStateListItem[];
    taskPriorities: TaskPriorityListItem[];
    units: IdTitleNode[];

    constructor();
    constructor(obj: ITaskTypeEdit);
    constructor(obj?: any) {
        this.item = new TaskTypeEditItem(obj ? obj.item : null);
        this.taskTypeUnits = Base.getTypedArray(obj?.taskTypeUnits, RecordUnit);
        this.taskStates = Base.getTypedArray(obj?.taskStates, TaskStateListItem);
        this.taskPriorities = Base.getTypedArray(obj?.taskPriorities, TaskPriorityListItem);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
    }
}